import { all, call, put, takeLatest } from "redux-saga/effects";
import { http } from "../../common/lib";
import config from "../../config";
import { actionCreators, actionTypes } from "./actions";
import { logToSentry } from "../../config/Sentry";

function* get(action) {
    try {
        const { data } = yield call(
            http.authorized.get
            // config.api.paths.auditAssignmentBulkUpdate,
            // auditAssignments
        );
        yield put(actionCreators.bulkUpdatePostSuccess(data));
    } catch (error) {
        logToSentry("On audit assignments get:", { error });
        console.error(error);
        yield put(actionCreators.bulkUpdatePostFailure(error));
    }
}

function* bulkUpdatePost(action) {
    const { auditAssignments } = action.payload;
    try {
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.auditAssignmentBulkUpdate,
            auditAssignments
        );
        yield put(actionCreators.bulkUpdatePostSuccess(data));
    } catch (error) {
        logToSentry("On audit assignments bulk update post:", { error });
        console.error(error);
        yield put(actionCreators.bulkUpdatePostFailure(error));
    }
}

function* patch(action) {
    const { auditAssignmentId, orgId, status } = action.payload;
    try {
        const url = `${config.api.paths.auditAssignmentsOrg}${auditAssignmentId}/?organisation=${orgId}`;
        const { data } = yield call(http.authorized.patch, url, status);
        yield put(actionCreators.patchSuccess(data));
    } catch (error) {
        logToSentry("On audit assignments patch:", { error });
        console.error(error);
        yield put(actionCreators.patchFailure(error));
    }
}

function* post(action) {
    const { auditAssignments } = action.payload;
    try {
        const { data } = yield call(
            http.authorized.post,
            config.api.paths.auditAssignments,
            auditAssignments
        );
        yield put(actionCreators.postSuccess(data));
    } catch (error) {
        logToSentry("On audit assignments post:", { error });
        console.error(error);
        yield put(actionCreators.postFailure(error));
    }
}

export default function* () {
    yield all([
        takeLatest(actionTypes.AUDIT_ASSIGNMENTS_POST_REQUEST, post),
        takeLatest(actionTypes.AUDIT_ASSIGNMENTS_PATCH_REQUEST, patch),
        takeLatest(
            actionTypes.AUDIT_ASSIGNMENTS_BULK_UPDATE_POST_REQUEST,
            bulkUpdatePost
        )
    ]);
}
